import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import "../App.scss";
import MultipleEntryPassAdd from "../components/MultipleEntryPass/MultipleEntryPassAdd";
import MultipleEntryPassItem from "../components/MultipleEntryPass/MultipleEntryPassItem";
import MultipleEntryPassWidget from "../components/MultipleEntryPass/MultipleEntryPassWidget";
import {
  activeMultipleEntryPassesSelector,
  canBuyNewMultipleEntryPassSelector,
  hasActiveMultipleEntryPassSelector,
  inactiveMultipleEntryPassesSelector,
  purchasePassReasonFlagSelector,
} from "../store/multipleEntryPassSlice";

import { isPartnerClalit } from "../store/partnerStore";
import "../styles/multipleEntryPass.scss";

const MultipleEntryPass = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isClalit = useSelector(isPartnerClalit);
  const isHaveCard = useSelector((state) => state.userSlice.isHaveCreditCard);

  const canBuyNewMultipleEntryPass = useSelector(
    canBuyNewMultipleEntryPassSelector
  );

  const hasActiveMultipleEntryPass = useSelector(
    hasActiveMultipleEntryPassSelector
  );

  const regularOrderFoundFlag = useSelector(purchasePassReasonFlagSelector);

  const canBuyPass = !hasActiveMultipleEntryPass && canBuyNewMultipleEntryPass;

  const activePasses = useSelector(activeMultipleEntryPassesSelector);
  const inactivePasses = useSelector(inactiveMultipleEntryPassesSelector);

  return (
    <div className="multiple-entry-pass">
      <Typography className="multiple-entry-pass__header">
        {t("ACTIVE_MULTIPLE_ENTRY_PASS")}
      </Typography>
      <div className="multiple-entry-pass__list">
        {activePasses.map((pass, index) => (
          <MultipleEntryPassItem
            key={pass.ID}
            pass={pass}
            index={index}
            array={activeMultipleEntryPassesSelector}
            onClick={() =>
              navigate("/multipleEntryPassDetails", { state: { pass } })
            }
          />
        ))}
        {canBuyPass && (
          <MultipleEntryPassAdd
            onClick={() =>
              navigate(isHaveCard ? "/multipleEntryPassPurchase" : "/addCard")
            }
          />
        )}
        <div>
          {!hasActiveMultipleEntryPass &&
            !canBuyNewMultipleEntryPass &&
            !regularOrderFoundFlag && <MultipleEntryPassWidget isNew={false} />}
        </div>
      </div>

      <Typography className="multiple-entry-pass__header">
        {t("INACTIVE_MULTIPLE_ENTRY_PASS")}
      </Typography>
      <div className="multiple-entry-pass__list">
        {inactivePasses.map((pass, index) => (
          <MultipleEntryPassItem
            key={pass.ID}
            pass={pass}
            index={index}
            array={inactiveMultipleEntryPassesSelector}
            onClick={() =>
              navigate("/multipleEntryPassDetails", { state: { pass } })
            }
          />
        ))}
      </div>
    </div>
  );
};

export default MultipleEntryPass;
